import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "item", "prevBtn", "nextBtn", "pageInfo"]
  static values = { perPage: { type: Number, default: 3 } }

  connect() {
    this.currentPage = 0
    this.updateView()
  }

  get totalItems() {
    return this.itemTargets.length
  }

  get totalPages() {
    return Math.ceil(this.totalItems / this.perPageValue)
  }

  next() {
    if (this.currentPage < this.totalPages - 1) {
      this.currentPage++
      this.updateView()
    }
  }

  previous() {
    if (this.currentPage > 0) {
      this.currentPage--
      this.updateView()
    }
  }

  updateView() {
    const start = this.currentPage * this.perPageValue
    const end = start + this.perPageValue

    // Show/hide items
    this.itemTargets.forEach((item, index) => {
      if (index >= start && index < end) {
        item.classList.remove("hidden")
      } else {
        item.classList.add("hidden")
      }
    })

    // Update button states
    if (this.hasPrevBtnTarget) {
      this.prevBtnTarget.disabled = this.currentPage === 0
    }
    if (this.hasNextBtnTarget) {
      this.nextBtnTarget.disabled = this.currentPage >= this.totalPages - 1
    }

    // Update page info
    if (this.hasPageInfoTarget) {
      const displayStart = start + 1
      const displayEnd = Math.min(end, this.totalItems)
      this.pageInfoTarget.textContent = `${displayStart}-${displayEnd} of ${this.totalItems}`
    }
  }
}

